var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("collapse-transition", [
    _c(
      "ul",
      {
        staticClass: "tree-list nav-child-indent",
        attrs: { role: "menu", "data-widget": "treeview", id: _vm.id },
      },
      _vm._l(_vm.nodes, function (node) {
        return _c("NodeTreeLayers", {
          key: `node-tree-${node.id}`,
          ref: `node-tree-${node.id}`,
          refInFor: true,
          attrs: {
            depth: 1,
            map: _vm.map,
            node: node,
            parentNode: node,
            showRoot: _vm.showRoot,
            showCheckbox: _vm.showCheckbox,
            actions: _vm.nodeActions,
            activeSelect: _vm.activeSelect,
            minimumIconSize: _vm.minimumIconSize,
          },
          on: {
            emitNodeAction: _vm.onNodeAction,
            emitNodeChecked: _vm.onNodeChecked,
            emitNodeCollapsed: _vm.onNodeCollapsed,
            emitNodeSelected: _vm.onNodeSelected,
            emitNodeDeleted: _vm.onNodeDeleted,
            emitNodeAdded: _vm.onNodeAdded,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }